export const asProject = {
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6667 2L13.56 2.02L10 3.4L6 2L2.24 3.26667C2.1 3.31333 2 3.43333 2 3.58667V13.6667C2 13.8533 2.14667 14 2.33333 14L2.44 13.98L6 12.6L10 14L13.76 12.7333C13.9 12.6867 14 12.5667 14 12.4133V2.33333C14 2.14667 13.8533 2 13.6667 2ZM6.66667 3.64667L9.33333 4.58V12.3533L6.66667 11.42V3.64667ZM3.33333 4.30667L5.33333 3.63333V11.4333L3.33333 12.2067V4.30667ZM12.6667 11.6933L10.6667 12.3667V4.57333L12.6667 3.8V11.6933Z"/>
  </svg>
  `,
  name: 'project',
};
